import { EntityStatusModel } from '@abb-procure/data';
import { BooleanInput } from '@angular/cdk/coercion';
import {
  Component,
  booleanAttribute,
  computed,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Badge } from '../badge/badge.component';
import { EntityBadge } from '../entity-badge/entity-badge.component';
import { StatusBadge } from '../status-badge/status-badge.component';

@Component({
  selector: 'procure-page-header-statuses',
  templateUrl: './page-header-statuses.component.html',
  styleUrl: './page-header-statuses.component.scss',
  imports: [StatusBadge, Badge, EntityBadge, MatTooltip],
  host: {
    '[class.editable]': 'isTitleEditable()',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PageHeaderStatuses {
  readonly status = input<EntityStatusModel | null>();
  readonly template = input<string | null>();
  readonly additionalStatus = input<string | null>();
  readonly priority = input<number | null>();

  readonly isTitleEditable = input<boolean, BooleanInput>(true, {
    transform: booleanAttribute,
  });

  protected readonly priorityLabel = computed(() => {
    const priority = this.priority();

    if (!priority) {
      return null;
    }

    return `#${priority}`;
  });
}
